<template>
  <div>
    <v-row dense class="mx-1">
      <v-btn v-if="hasModuleGerencia"
             color="primary"
             class="normal-btn-text rounded-tag-small elevation-0"
             link to="/tabelas-preco/cadastro">
        <v-icon left>mdi-plus</v-icon>
        Tabela de preço
      </v-btn>
      <v-spacer/>
      <v-btn icon @click="onClickRefresh">
        <v-icon left>mdi-refresh</v-icon>
      </v-btn>
      <px-search-text label="Busque por código, fornecedor ou descrição"
                      class="rounded-tag-small"
                      v-model="searchText"
                      style="max-width: 400px"
                      :on-search="emitChange"/>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    onClickRefresh: {
      type: Function,
      required: true,
    },
  },
  computed: {
    ...mapGetters('user', ['hasModuleGerencia']),
    searchText: {
      get() {
        return this.$store.getters['listagemTabelasPreco/searchText'];
      },
      set(searchText) {
        this.$store.dispatch('listagemTabelasPreco/searchText', searchText);
      },
    },
  },
  methods: {
    emitChange() {
      this.$emit('change');
    },
  },
};
</script>
